import React from 'react';
import './DemoIndicator.css';
import ApiService from '../services/api';

const DemoIndicator = () => {
  const isDemoMode = ApiService.isDemoMode();

  if (!isDemoMode) return null;

  return (
    <div className="demo-indicator">
      <div className="demo-badge">
        <span className="demo-icon">🎭</span>
        <span className="demo-text">MODE DÉMO</span>
        <span className="demo-description">
          Backend non disponible - Données simulées
        </span>
      </div>
    </div>
  );
};

export default DemoIndicator;
